/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:53:12
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "@root/core/tags";

// uicSummary provide custom rule for "summary" for "audit".
@UITag.set()
export class uicSummaryOptions extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;
        if (rule == false) return null;

        let moreTags: IUITagMoreTagsUnit[] = [
            {
                tag: "uiLabel",
                rule: "提交審核",
            },
            {
                tag: "uiType",
                rule: "iv-form-check",
            },
            {
                tag: "uiSubmitIgnore",
                rule: "true",
            },
            {
                tag: "uiEnum",
                rule: `() => ({ "資料確認無誤": 0, "其他": 1 })`,
            },
            // {
            //     tag: "uiDefault",
            //     rule: `() => 0`,
            // },
            {
                tag: "uiMeta",
                rule: `{ detail: false }`,
            },
        ];

        return {
            specials: {
                moreTags,
            },
        };
    }
}
